import React from 'react';
import { Link } from 'react-router-dom'; // Импортируем Link
import '../../styles/collection.css';
import { useLanguage } from "../common/LanguageContext";

function Collection() {
  const { translations } = useLanguage();

  console.log(translations.collectionPage.model1.features);

  const models = [
    {
      image: '/slide1.png',
      title: translations.collectionPage.model1.title,
      link: '/models/loft1', // Ссылка на страницу модели
      features: translations.collectionPage.model1.features,
    },
    {
      image: '/slide2.png',
      title: translations.collectionPage.model2.title,
      link: '/models/lotus',
      features: translations.collectionPage.model2.features,
    },
    {
      image: '/slide3.png',
      title: translations.collectionPage.model3.title,
      link: '/models/classic',
      features: translations.collectionPage.model3.features,
    },
    {
      image: '/slide4.png',
      title: translations.collectionPage.model4.title,
      link: '/models/minimalism',
      features: translations.collectionPage.model4.features,
    },
    {
      image: '/slide5.png',
      title: translations.collectionPage.model5.title,
      link: '/models/loft2',
      features: translations.collectionPage.model5.features,
    },
  ];

  return (
    <div className="collection-page">
      <h1 className="collection-title">{translations.collectionPage.title}</h1>
      <div className="collection-grid">
        {models.map((model, index) => (
          <div key={index} className="collection-item">
            <img src={model.image} alt={model.title} className="collection-image" />
            <h2 className="collection-item-title">
              <Link to={model.link} className="model-link">{model.title}</Link>
            </h2>
            <div className="order-name">{translations.collectionPage.additionalText}</div>
            <ul className="collection-features">
              {model.features.map((feature, idx) => (
                <li key={idx} className="feature-item">
                  — {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Collection;
